// Typelizer digest 899c9df2674c25e26540eba5fd9093c2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/company_identity_confirmation */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/company_identity_confirmation', {}, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/company_identity_confirmation */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/company_identity_confirmation', {}, options),
    method: 'patch',
  }),
}
